import React, { useState } from 'react';
import './ApplicationForm.css';
import { useLocation, useNavigate } from 'react-router-dom';

export default function ApplicationForm() {
  const location = useLocation();
  const navigate = useNavigate();
  const job = location.state?.job || { id:'', title: '' };

  const [form, setForm] = useState({
    position: job.title || '',
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [cvFile, setCvFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  }

  function handleFile(e) {
    const file = e.target.files[0];
    if (file) setCvFile(file);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      // Prepare optional CV as dataUrl (read file if provided)
      let cv = null;
      if (cvFile) {
        cv = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => resolve({ name: cvFile.name, type: cvFile.type, size: cvFile.size, dataUrl: reader.result });
          reader.onerror = () => resolve(null);
          reader.readAsDataURL(cvFile);
        });
      }
      const payload = {
        name: form.name,
        email: form.email,
        phone: form.phone,
        message: form.message,
        position: form.position,
        jobId: job.id || '',
        jobTitle: job.title || form.position,
        cv
      };
      const base = process.env.REACT_APP_PUBLICATION_SERVICE || 'http://localhost:4300';
      const res = await fetch(base + '/applications', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });
      const json = await res.json().catch(()=>null);
      if (!res.ok || (json && json.success === false)) {
        const msg = (json && json.error && json.error.message) || `HTTP ${res.status}`;
        throw new Error(msg);
      }
      alert('Candidature envoyée. Merci !');
      navigate('/careers');
    } catch(err){
      alert('Erreur lors de l\'envoi: ' + (err.message || 'inconnue'));
      setSubmitting(false);
    }
  }

  const allValid = (
    (form.position||'').trim() &&
    (form.name||'').trim() &&
    (form.email||'').trim() &&
    (form.phone||'').trim() &&
    (form.message||'').trim() &&
    !!cvFile
  );

  return (
    <form className="contact-form application-form" onSubmit={handleSubmit}>
      <label>
        Poste
        <input name="position" value={form.position} onChange={handleChange} disabled required style={{ background:'#f1f5f9', color:'#64748b' }} />
      </label>

      <div className="row">
        <label>
          Nom complet
          <input name="name" value={form.name} onChange={handleChange} required />
        </label>
      </div>

      <div className="row">
        <label>
          Email
          <input name="email" type="email" value={form.email} onChange={handleChange} required />
        </label>
        <label>
          Téléphone
          <input name="phone" value={form.phone} onChange={handleChange} required />
        </label>
      </div>

      <label>
        Lettre / Message
        <textarea name="message" value={form.message} onChange={handleChange} rows={6} required />
      </label>

      <label className="file">
        Joindre CV (PDF / DOCX)
        <input type="file" accept=".pdf,.doc,.docx" onChange={handleFile} required />
        {cvFile && <div className="file-name">{cvFile.name}</div>}
      </label>

      <div className="actions">
        <button type="button" className="btn-secondary" onClick={() => navigate(-1)} style={{ marginRight: 8, display: 'inline-flex', alignItems: 'center', gap: 8 }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
            <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          Retour
        </button>
        <button className="btn-primary" type="submit" disabled={submitting || !allValid}>{submitting ? 'Envoi...' : 'Envoyer'}</button>
      </div>
    </form>
  );
}
